import common from './common'
import data from './data'

import testEvaluation from './testEvaluation'
// import studentEvaluation from './studentEvaluation'

export default [...common, ...testEvaluation, ...data]
